import { MapControls, OrbitControls } from '@react-three/drei';
import { gsap } from 'gsap';
import { ControlContext } from 'provider/ControlProvider';
import { useContext, useEffect, useRef, useState } from 'react';
import { Vector3 } from 'three';

export default function Controls() {
  const { pinInfo, end } = useContext(ControlContext);
  const [show, setShow] = useState(false);
  const controlsRef = useRef<any>(!null);
  const mapControlRef = useRef<any>(!null);
  const tl = gsap.timeline();
  const CameraMove = () => {
    if (controlsRef.current && mapControlRef.current) {
      gsap.to(controlsRef.current.target, {
        onStart: () => {
          controlsRef.current.target.copy(mapControlRef.current.target);
          controlsRef.current.minDistance = 0;
        },
        duration: 2,
        ease: 'power2.out',
        x: pinInfo.pos[0] - 1.38,
        y: pinInfo.pos[1],
        z: pinInfo.pos[2] + 0.16,
      });
      gsap.to(controlsRef.current, {
        duration: 2,
        ease: 'power2.out',
        maxDistance: window.innerWidth >= 1024 ? 0.15 : 0.3,
        onComplete: () => {
          controlsRef.current.maxDistance = 4;
        },
      });
    }
  };
  const CameraInit = () => {
    gsap.to(controlsRef.current, {
      onStart: () => {
        controlsRef.current.maxDistance = 4;
      },
      duration: 3,
      ease: 'power1',
      minDistance: 3,
      onComplete: () => {
        controlsRef.current.minDistance = 0;
        mapControlRef.current.target = controlsRef.current.target;
        setShow(false);
      },
    });
  };
  useEffect(() => {
    mapControlRef.current.addEventListener('change', function () {
      if (mapControlRef.current.target.z < -1.5) {
        mapControlRef.current.target.z = -1.5;
      } else if (mapControlRef.current.target.z > 1.5) {
        mapControlRef.current.target.z = 1.5;
      }
      if (mapControlRef.current.target.x < -1.5) {
        mapControlRef.current.target.x = -1.5;
      } else if (mapControlRef.current.target.x > 1.5) {
        mapControlRef.current.target.x = 1.5;
      }
    });
  });
  useEffect(() => {
    if (controlsRef.current && mapControlRef.current) {
      if (pinInfo.index === 0) CameraInit();
      else if (show) CameraMove();
      if (pinInfo.index !== 0) setShow(true);
    }
  }, [pinInfo.index, controlsRef, show]);
  return (
    <group>
      <MapControls
        ref={mapControlRef}
        maxDistance={3}
        minPolarAngle={0}
        maxPolarAngle={Math.PI / 2.5}
        zoomSpeed={0.5}
        enabled={end && !show}
        panSpeed={0.7}
      />
      <OrbitControls
        ref={controlsRef}
        maxDistance={4}
        minPolarAngle={0}
        maxPolarAngle={Math.PI / 3}
        zoomSpeed={0.7}
        enableDamping={true}
        enabled={end && show}
      />
    </group>
  );
}
